import { cx } from "@/utils/cx";

type ModePillProps<T extends string> = {
  options: { value: T; label: string; isDisabled?: boolean }[];
  value: T;
  onChange: (next: T) => void;
  isDisabled?: boolean;
};

export function ModePill<T extends string>({ options, value, onChange, isDisabled }: ModePillProps<T>) {
  return (
    <div className="inline-flex items-center rounded-full bg-secondary p-0.5">
      {options.map((opt) => {
        const active = opt.value === value;
        const optionDisabled = isDisabled || opt.isDisabled;
        return (
          <button
            key={opt.value}
            type="button"
            disabled={optionDisabled && !active}
            className={cx(
              "px-3 py-1 text-xs font-medium rounded-full transition-colors disabled:cursor-not-allowed disabled:opacity-50",
              active ? "bg-primary text-primary shadow-sm" : "text-tertiary hover:text-secondary",
            )}
            onClick={() => !active && !optionDisabled && onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
